import moment from 'moment';

moment.updateLocale('en', {
  relativeTime: {
    future: 'in %s',
    past: (key) => (key !== 'just now' ? `${key} ago` : key),
    s: (isFuture) => (isFuture ? 'just now' : 'a second'),
    ss: (isFuture, key) => (isFuture ? 'just now' : `${key} seconds`),
    m: '1 min',
    mm: '%d mins',
    h: '1 hr',
    hh: '%d hrs',
    d: '1 day',
    dd: '%d days',
    w: '1 week',
    ww: '%d weeks',
    M: '1 month',
    MM: '%d months',
    y: '1 year',
    yy: '%d years',
  },
});
